import React, { useState, useEffect } from 'react';
import LBInput from '../../DesignSystem/LBInput/LBInput';

function SearchFilter({selectCompanyHandler, clearFilter, field, isBeingChanged}) {
  const [ searchVal, setSearchVal ] = useState('');

  // Reset internal state when clearFilter becomes true, but only if this field is NOT being changed
  useEffect(() => {
    if (clearFilter === true && !isBeingChanged) {
      setSearchVal('');
    }
  }, [clearFilter, isBeingChanged]);

  const handleSearch = (key) => {
    key.preventDefault()
    setSearchVal(key.target.value)
    selectCompanyHandler(field, {label: key.target.value, value: key.target.value})
  }

  return (
      <LBInput 
        label="Search by Name"
        placeholder="Filter by Name"
        aria-label="Filter by Name"
        onChange={(e) => handleSearch(e)}
        value={clearFilter === true && !isBeingChanged ? '' : searchVal}
      />
  )
}

export default SearchFilter;